import React, { Component } from "react";
import { AuthLogin } from "../../services/auth-service";
import { restauth, app } from "../../index";
import { modalhandler } from "../../actions/modal-handler";
import { bindActionCreators } from "redux";
import { grabservice } from "../../services/crudservice";
import { connect } from "react-redux";
import { hashHistory } from "react-router";
import {
  Icon,
  Modal,
  Header,
  Input,
  Form,
  Button,
  Image,
  Dropdown,
  Grid,
  Table,
  Divider
} from "semantic-ui-react";
import { estformatnumber } from "../../services/tnminvnumbers";
class EstimateList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      billinginfo: null,
      wod: null,
      resultdrop: "",
      estimates: [],
      filteroptions: [],
      searchparams: "",
      results: props.workorders,
      datatype: "",
      resultkey: ""
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.showModal && !prevProps.showModal) {
      grabservice("estimates").then(response =>
        this.setState({
          estimates: response
        })
      );
    }
  }
  componentDidMount() {
    grabservice("estimates").then(response =>
      this.setState({
        estimates: response
      })
    );
  }
  filter_object_values(obj) {
    if (obj) {
      return Object.values(obj).filter(
        p => typeof p === "number" || typeof p === "string"
      );
    }
  }
  genresultrows() {
    let sp = this.state.searchparams;
    return this.state.estimates.map(est => {

      let creator = this.props.employees.find(
        emp => emp.empnumber === parseInt(est.creator)
      );

      let customer = this.props.customers.find(
        cust => cust.custnumber === est.custnumber
      );
      let match = false;

      est.formattednumber = estformatnumber(est);
      let params = this.filter_object_values(est);
      params = params.concat(this.filter_object_values(customer));
      if (creator) {
        params = params.concat(this.filter_object_values(creator));
      } else {
        creator = { firstname: "N/", lastname: "A" };
      }

      params.forEach(param => {
        if (typeof param === "number") {
          param = param.toString();
        }
        if (param.toLowerCase().includes(sp.toLowerCase())) {
          match = true;
        }
      });

      if (match) {
        return (
          <Table.Row
            onClick={() => {
              hashHistory.push("/estimatereview/" + est.id);
              window.location.reload();
            }}
          >
            <Table.Cell> {est.formattednumber} </Table.Cell>
            <Table.Cell> {customer.custname} </Table.Cell>
            <Table.Cell> {est.program} </Table.Cell>
            <Table.Cell> {est.description} </Table.Cell>
            <Table.Cell> {est.total} </Table.Cell>
            <Table.Cell> {est.createDate} </Table.Cell>
            <Table.Cell>
              {creator.firstname + " " + creator.lastname}
            </Table.Cell>
          </Table.Row>
        );
      }
    });
  }
  genresulttable() {
    if (this.state.estimates.length) {
      return (
        <Table celled selectable compact>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell> Estimate# </Table.HeaderCell>
              <Table.HeaderCell> Customer </Table.HeaderCell>
              <Table.HeaderCell> Program </Table.HeaderCell>
              <Table.HeaderCell> Description </Table.HeaderCell>
              <Table.HeaderCell> Total </Table.HeaderCell>
              <Table.HeaderCell> Create Date </Table.HeaderCell>
              <Table.HeaderCell> Creator </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body> {this.genresultrows()} </Table.Body>
        </Table>
      );
    }
  }

  render() {
    if (
      this.props.customers &&
      this.props.customers.length &&
      this.props.employees &&
      this.props.employees.length
    ) {
      return (
        <div className="WodSearchModal">
          <Modal
            open={this.props.showModal}
            basic
            onClose={() => {
              this.props.handlemodal("none");
              this.setState({
                searchparams: ""
              });
            }}
          >
            <Header> Find Estimate </Header>
            <Modal.Content>
              <Grid>
                <Grid.Row>
                  <Grid.Column width={8}>
                    <Input
                      fluid
                      label="Search"
                      onChange={e =>
                        this.setState({
                          searchparams: e.target.value
                        })
                      }
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Divider />
              {this.genresulttable()}
            </Modal.Content>
            <Modal.Actions />
          </Modal>
        </div>
      );
    } else {
      return <div />;
    }
  }
}

function mapStateToProps(state) {
  return {
    showModal: state.modal === "estimatesearchmodal",
    employees: state.employees.employees,
    customers: state.custinfo.customers
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      handlemodal: modalhandler
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  matchDispatchToProps
)(EstimateList);



// WEBPACK FOOTER //
// ./src/components/shared-components/estimatesearchmodal.js